/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type app_v1_instruments_InstrumentsPriceArgs = {
    base_currency: app_v1_instruments_InstrumentsPriceArgs.base_currency;
    tickers: string;
};

export namespace app_v1_instruments_InstrumentsPriceArgs {

    export enum base_currency {
        USD = 'USD',
        EUR = 'EUR',
        SEK = 'SEK',
        BRL = 'BRL',
        GBP = 'GBP',
        GBX = 'GBX',
    }


}

